<div bsModal #doLaterModal="bs-modal" class="modal fade trovve-sm-modal z-index-1110" id="DoLaterModal"
  tabindex="-1" [config]="{backdrop: 'static', keyboard: false}">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content box-shadow-popup rounded-12">
      <div class="modal-header d-block p-0 border-0">
        <div class="row mx-0">
          <div class="col px-0 align-self-center font-weight-medium text-vf-dark f-size-16">
            Do later
          </div>
          <div class="col px-0">
            <div class="float-right d-flex justify-content-end text-right w-100 h-100">
              <button type="button" class="float-right d-flex modal-close-icon" (click)="close()"
                aria-label="Close">
                <ibm-icon-close size="16"></ibm-icon-close>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body p-3 border rounded-8 bg-section my-3 mx-0">
        <div class="row pb-2">
          <div class="col">
            <span class="text-vf-dark f-size-14 font-weight-medium">When do you want to work on it?</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="my-10 d-flex flex-column align-items-start">
              <div class="custom-control custom-radio custom-radio-success custom-control-inline mr-4 mb-1">
                <input type="radio" id="date-tomorrow" name="date-tom" class="custom-control-input"
                  [(ngModel)]="isDateSelected" [value]="false" (change)="chooseDate(isDateSelected)">
                <label class="custom-control-label text-vf-dark f-size-14 pt-1" for="date-tomorrow">Tomorrow</label>
              </div>
              <div class="custom-control custom-radio custom-radio-success adjust custom-control-inline mr-4 mb-1">
                <input type="radio" id="date-specific" name="date-spec" class="custom-control-input"
                  [(ngModel)]="isDateSelected" [value]="true" (change)="chooseDate(isDateSelected)">
                <label class="custom-control-label text-vf-dark f-size-14 pt-1" for="date-specific"
                  *ngIf="!dateString">Choose a specific date</label>
                <label class="custom-control-label text-blue f-size-14 pt-1" for="date-specific" (click)="updateShowDatePicker()"
                  *ngIf="selectedDate && isDateSelected && dateString">{{dateString}}</label>
              </div>
              <div class="d-flex rounded-24 px-2 py-1 bg-new border-grey" *ngIf="showDatePicker">
                <input type="text" class="w-100 border-none bg-transparent" style="outline: none;" id="doLaterDtPicker"
                  placeholder="Start date" autocomplete="off" (keydown)="preventKeyDown($event)" />
                <lucide-icon name="calendar" [size]="16" [strokeWidth]="2" class="ml-2" *ngIf="!selectedDate"></lucide-icon>
                <lucide-icon name="x" [size]="9" [strokeWidth]="2" class="cursor-pointer" (click)="clearStartDate()" *ngIf="selectedDate"></lucide-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer text-center d-flex p-0">
        <button type="button" (click)="close()"
          class="btn cancel-btn rounded-8 py-10 w-100 ml-0">Cancel
        </button>
        <button type="button"
          class="btn btn-black rounded-8 py-10 w-100 mr-0"
          [disabled]="isDateSelected && !selectedDate" (click)="save()">Save</button>
      </div>
    </div>
  </div>
</div>